// The PAC (Edicom) answers with a Java/SOAP fault chain:
//   soapenv:Server.userException: com.edicom...CFDiException: CFDI40148: El campo ...
// Everything before the SAT code is noise to whoever has to fix the invoice, so
// lead with the part that actually names the problem.
export function pacErrorMessage(raw) {
  if (!raw) return '';
  const text = String(raw).trim();

  // SAT codes look like CFDI40148 / CRP20012. Keep from the code onwards.
  const satCode = text.match(/([A-Z]{3,6}\d{2,6}\s*:\s*[\s\S]+)$/);
  if (satCode) return satCode[1].trim();

  // Otherwise drop the Java exception chain and keep the trailing message.
  const parts = text.split(/[A-Za-z0-9_.]*Exception\s*:\s*/);
  return (parts.length > 1 ? parts[parts.length - 1] : text).trim();
}
